// Cutout positions measured directly from the alpha channel of Theme1/2/3.PNG
// (identical across all three frames). Expressed as fractions of the frame's
// full width/height so they scale to any render size.
const PHOTO_AREA_PERCENTS = [
  { x: 0.0656, y: 0.0274, width: 0.8681, height: 0.1955 },
  { x: 0.0656, y: 0.2386, width: 0.8681, height: 0.1929 },
  { x: 0.0656, y: 0.4477, width: 0.8681, height: 0.1933 },
  { x: 0.0656, y: 0.6579, width: 0.8681, height: 0.1938 },
];

export const getPhotoAreas = (frameWidth, frameHeight) =>
  PHOTO_AREA_PERCENTS.map((p) => ({
    x: frameWidth * p.x,
    y: frameHeight * p.y,
    width: frameWidth * p.width,
    height: frameHeight * p.height,
  }));
